import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { TransmissionStationService } from '../../services/transmission-station.service';
import { CrudTsFilter, TransmissionStation } from '../../models/transmission-station.model';
import { ToastrService } from 'ngx-toastr';
import { UtilitySharedService } from '../../services/shared/utility-shared.service';

@Component({
  selector: 'lib-crud-ts',
  templateUrl: './crud-ts.component.html',
  styleUrls: ['./crud-ts.component.scss'],
  standalone: false
})
export class CrudTsComponent implements OnInit, OnChanges {
  @Input() downloadClicked: boolean = false;
  @Input() reloadTableInput: boolean = false;

  count: number = 0;
  currentPage: number = 1;
  pageSize = 10;
  transmissionStations: TransmissionStation[] = [];
  utilityId: number = 1;
  searchText: string = "";

  selectedTs: TransmissionStation = new TransmissionStation();
  updatedName: string = '';
  isEditMode: boolean = false;
  showDeleteModal: boolean = false;

  @ViewChild('filterTemplate', { static: true })
  filterTemplate!: TemplateRef<any>;

  @Output() filterTemplateReady = new EventEmitter<TemplateRef<any>>();

  @Input() set refreshTrigger(_: number) {
    this.filterTemplateReady.emit(this.filterTemplate);
  }

  @ViewChild('closeEditModal') closeEditModal!: ElementRef;

  constructor(private tsService: TransmissionStationService, private toastr: ToastrService, private utilitySharedService: UtilitySharedService) {
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['downloadClicked']) {
      const val = changes['downloadClicked'].currentValue;
      if (val) 
        this.download();    
    } else if (changes['reloadTableInput']) {
        setTimeout(() => {
          this.reloadTable(1);
        }, 500);
    }
  }

  ngOnInit(): void {
    this.filterTemplateReady.emit(this.filterTemplate);
    this.reloadTable(1);
  }

  onPageChange(newPage: number) {
    this.currentPage = newPage;
    this.reloadTable(newPage);
  }

  private getFilterObject(): any {
    const obj = {
      searchValue: this.searchText
    }
    return obj;
  }

  private getAllTss(dataIn: any) {
    this.tsService.getAll(dataIn).subscribe({
      next: (response) => {
        this.transmissionStations = response.data.data;
        this.count = response.data.count;
        if (this.count == 0) {
          this.toastr.info('No data for given input.');
        }
      },
      error: (_) => this.toastr.error('An error occurred.'),
    });
  }

  reloadTable(page: number | null = null) {
    if (page) this.currentPage = page;
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: this.getFilterObject(),
      utilityId: this.utilityId
    };
    this.getAllTss(obj);
  }

  deleteTs() {
    this.tsService.delete(this.selectedTs.id).subscribe({
      next: (response: any) => {
        if (response.status === 200 || response.status === 'OK') {
          this.onPageChange(1);
          this.toastr.success(response.message);
          this.showDeleteModal = false;
        } else {
          this.toastr.error(response.message);
        }
      },
      error: (_) => this.toastr.error('Error occurred'),
    });
  }

  selectTs(selectedTs: TransmissionStation) {
    this.selectedTs = selectedTs;
    this.isEditMode = true;
    this.fillInputFields();
  }
  
  onDeleteTs(selectedTs: TransmissionStation){
    this.selectedTs = selectedTs;
    this.isEditMode = false;
    this.showDeleteModal = true;
  }

  openAddModal() {
    this.isEditMode = false;
    this.selectedTs = new TransmissionStation();
    this.updatedName = '';
  }

  private fillInputFields() {
    this.updatedName = this.selectedTs.name;
  }

  onDeleteCancel(){
    this.showDeleteModal = false;
  }

  closeDeleteModal() {
    this.showDeleteModal = false;
    this.selectedTs = new TransmissionStation();
  }

  download() {
    const dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: this.getFilterObject(),
      utilityId: this.utilityId,
    };

    this.tsService.downloadFile(dataIn).subscribe({
      next: (response: any) => {
        window.location.href = response.data;
      },
      error: (_) => {
        this.toastr.error('An error occurred.');
        this.reloadTable();
      }
    });
  }

  save() {
    const tsToSave = new TransmissionStation();
    tsToSave.utilityId = this.utilityId;
    tsToSave.name = this.updatedName;
    tsToSave.id = this.isEditMode ? this.selectedTs.id : 0;

    if (tsToSave.name === '') {
      this.toastr.warning("Name can't be empty!");
    } else {
      this.tsService.save(tsToSave).subscribe({
        next: (response) => {
          if (response.status === 200 || response.status === 'OK') {
            this.toastr.success(response.message);
            setTimeout(() => {        
              this.reloadTable(1);
              this.closeEditModal?.nativeElement?.click();
            }, 500);
          } else {
            this.toastr.error(response.message);
          }
        },
        error: (_) => this.toastr.error('Error occurred'),
      });
    }
  }

  onSearch() {
    this.reloadTable(1);
  }
}